<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết phiếu thu</h1>
      <div class="btn-group float-right">
        <button
          v-if="
            dataPermission.includes('SCON_RECEIPT_LINK_ID') &&
            !dataReceipt.linkReceiptCode &&
            dataReceipt.status == 'NEW'
          "
          @click="connectReceipts()"
          class="f12 font-medium btn btn-outline-secondary mr-2"
        >
          Liên kết phiếu thu
        </button>
        <button
          @click="showModalChangeCode()"
          v-if="
            dataReceipt.status === 'PENDING_APPROVAL' &&
            (dataReceipt.paymentType === 'CUSTOMER_TRANSFER' ||
              dataReceipt?.paymentType === 'E_COMMERCE')
          "
          class="f12 font-medium btn btn-outline-secondary mr-2"
        >
          Sửa mã GD
        </button>
        <button
          @click="createRefund(dataReceipt)"
          v-if="dataPermission.includes('CNPS_SCON_REFUND_CREATE') && dataReceipt.status === 'DONE'"
          class="f12 font-medium btn btn-outline-secondary"
        >
          Hoàn tiền
        </button>
        <button
          class="f12 font-medium btn btn-outline-secondary"
          v-if="
            (dataReceipt.status &&
              dataReceipt.status === 'NEW' &&
              dataPermission &&
              dataPermission.includes('SCON_RECEIPT_UPDATE')) ||
            dataUser.typeSale === 'SALE_DIRECTOR'
          "
          @click="editReceipts()"
        >
          Sửa
        </button>
        <button
          class="f12 font-medium btn btn-outline-secondary mr-2"
          v-if="canExportReceiptInvoice(dataReceipt)"
          @click="exportReceiptInvoice(dataReceipt)"
        >
          Xuất hoá đơn
        </button>
        <button
          class="f12 font-medium btn btn-outline-secondary mr-2"
          v-if="
            (dataReceipt.status &&
              dataReceipt.status === 'NEW' &&
              (dataReceipt.paymentType === 'CUSTOMER_CARD' ||
                dataReceipt.paymentType === 'SALE_CARD') &&
              dataPermission &&
              dataPermission.includes('SCON_RECEIPT_COLLECT')) ||
            dataUser.typeSale === 'SALE_DIRECTOR'
          "
          @click="collectedMoney()"
        >
          Thu tiền
        </button>
        <button
          class="f12 font-medium btn btn-outline-secondary"
          v-if="
            ((dataReceipt.paymentType === 'CUSTOMER_TRANSFER' ||
              dataReceipt?.paymentType === 'E_COMMERCE') &&
              dataReceipt.status === 'PENDING_APPROVAL' &&
              dataPermission &&
              dataPermission.includes('SCON_RECEIPT_APPROVE')) ||
            dataUser.typeSale === 'SALE_DIRECTOR'
          "
          @click="approveReceipt()"
        >
          Duyệt
        </button>
        <button
          class="f12 font-medium btn btn-outline-secondary"
          @click="sendApproved()"
          v-if="
            ((dataReceipt.paymentType === 'CUSTOMER_TRANSFER' ||
              dataReceipt?.paymentType === 'E_COMMERCE') &&
              dataReceipt.status === 'NEW') ||
            dataUser.typeSale === 'SALE_DIRECTOR'
          "
        >
          Gửi duyệt
        </button>
        <button
          class="f12 font-medium btn btn-outline-secondary"
          v-if="
            ((((dataReceipt.paymentType === 'CUSTOMER_TRANSFER' ||
              dataReceipt?.paymentType === 'E_COMMERCE') &&
              dataReceipt.status === 'PENDING_APPROVAL') ||
              dataReceipt.status === 'DONE') &&
              dataPermission &&
              dataPermission.includes('SCON_RECEIPT_REJECT')) ||
            dataUser.typeSale === 'SALE_DIRECTOR'
          "
          @click="showModalReject = true"
        >
          Từ chối
        </button>
        <button class="f12 font-medium btn btn-outline-secondary" @click="backToList()">
          <i class="bx bx-arrow-back"></i> Quay lại
        </button>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 form-row">
        <div class="col-12">
          <!-- <div class="alert alert-danger" role="alert">
            <p>A simple danger alert—check it out! </p>
          </div> -->
        </div>
        <div class="col-12">
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="ttc">
              <div class="form-row">
                <div class="col-sm-6">
                  <div class="form-detail">
                    <h1>Thông tin phiếu thu</h1>

                    <div class="form-group form-row">
                      <label for="" class="col-sm-4 col-form-label"
                        >Mã phiếu thu<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">{{ dataReceipt.receiptCode }}</p>
                      </div>
                    </div>

                    <div class="form-group form-row">
                      <label for="" class="col-sm-4 col-form-label"
                        >Hình thức thanh toán <span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataReceipt.paymentType | transformPaymentType(dataTypePayment) }}
                        </p>
                      </div>
                    </div>

                    <div class="form-group form-row">
                      <label for="" class="col-sm-4 col-form-label"
                        >Hình thức mua thiết bị <span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{
                            dataReceipt.devicePaymentType
                              | transformPaymentType(devicePaymentTypeData)
                          }}
                        </p>
                      </div>
                    </div>

                    <div class="form-group form-row">
                      <label for="" class="col-sm-4 col-form-label"
                        >Trạng thái<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          <span
                            class="badge"
                            v-bind:class="[dataReceipt.status ? dataReceipt.status : '']"
                          >
                            {{ dataReceipt.status | mapTextStatus(listState) }}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div class="form-group form-row">
                      <label for="" class="col-sm-4 col-form-label"
                        >Trạng thái hoá đơn<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          <span class="badge CANCEL" v-if="dataReceipt.invoiceCancel">
                            {{ 'Đã huỷ HĐ' }}
                          </span>
                          <span class="badge DONE" v-else>
                            {{ dataReceipt.invoiceStt === true ? 'Đã xuất HĐ' : 'Chưa xuất HĐ' }}
                          </span>
                        </p>
                      </div>
                    </div>

                    <div class="form-group form-row" v-if="dataReceipt.invoiceManual">
                      <label for="" class="col-sm-4 col-form-label"
                        >Phương thức tạo<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">Thủ công</p>
                      </div>
                    </div>

                    <div class="form-group form-row" v-if="dataReceipt.invoiceExportDate">
                      <label for="" class="col-sm-4 col-form-label"
                        >Thời gian xuất hoá đơn<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataReceipt.invoiceExportDate | formatDate('DD/MM/YYYY HH:mm:ss') }}
                        </p>
                      </div>
                    </div>
                    <div class="form-group form-row" v-if="dataReceipt.amount">
                      <label for="" class="col-sm-4 col-form-label"
                        >Số tiền phải thu<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataReceipt.amount | transformMoney }}
                        </p>
                      </div>
                    </div>
                    <div class="form-group form-row" v-if="dataReceipt.netAmount">
                      <label for="" class="col-sm-4 col-form-label"
                        >Số tiền thực nhận<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataReceipt.netAmount | transformMoney }}
                        </p>
                      </div>
                    </div>
                    <div class="form-group form-row" v-if="dataReceipt.invoiceCancelReason">
                      <label for="" class="col-sm-4 col-form-label"
                        >Lý do huỷ hoá đơn<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataReceipt.invoiceCancelReason }}
                        </p>
                      </div>
                    </div>

                    <div
                      class="form-group form-row"
                      v-if="dataReceipt.transferContent && dataReceipt.transferContent !== null"
                    >
                      <label for="" class="col-sm-4 col-form-label"
                        >Nội dung phải thu<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">{{ dataReceipt.transferContent }}</p>
                      </div>
                    </div>

                    <div
                      class="form-group form-row"
                      v-if="dataReceipt.description && dataReceipt.description !== null"
                    >
                      <label for="" class="col-sm-4 col-form-label"
                        >Mã serial<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">{{ dataReceipt.serialNumber }}</p>
                      </div>
                    </div>

                    <div class="form-group form-row">
                      <label for="" class="col-sm-4 col-form-label"
                        >Ngày đã thu<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataReceipt.receiptDate | formatDate }}
                        </p>
                      </div>
                    </div>

                    <div
                      class="form-group form-row"
                      v-if="
                        dataReceipt.paymentType &&
                        (dataReceipt.paymentType === 'CUSTOMER_CARD' ||
                          dataReceipt.paymentType === 'SALE_CARD')
                      "
                    >
                      <label for="" class="col-sm-4 col-form-label"
                        >Ngày thanh toán<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataReceipt.payDate | formatDate('HH:mm, DD/MM/YYYY') }}
                        </p>
                      </div>
                    </div>

                    <div class="form-group form-row">
                      <label for="" class="col-sm-4 col-form-label"
                        >Mã giao dịch đã thu<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataReceipt.transactionCode }}
                        </p>
                      </div>
                    </div>
                    <div class="form-group form-row">
                      <label for="" class="col-sm-4 col-form-label"
                        >Mã hợp đồng<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataReceipt.contractCode }}
                        </p>
                      </div>
                    </div>

                    <div
                      class="form-group form-row"
                      v-if="
                        dataReceipt.paymentType && dataReceipt.paymentType === 'CUSTOMER_TRANSFER'
                      "
                    >
                      <label for="" class="col-sm-4 col-form-label"
                        >STK ngân hàng nhận tiền<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">{{ dataReceipt.issuerName }}</p>
                      </div>
                    </div>

                    <div
                      class="form-group form-row"
                      v-if="dataReceipt.note && dataReceipt.note !== null"
                    >
                      <label for="" class="col-sm-4 col-form-label"
                        >Ghi chú<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">{{ dataReceipt.note }}</p>
                      </div>
                    </div>

                    <div
                      class="form-group form-row"
                      v-if="dataReceipt.saleName && dataReceipt.saleMail"
                    >
                      <label for="" class="col-sm-4 col-form-label"
                        >Chuyên viên kinh doanh<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataReceipt.saleName }} - {{ dataReceipt.saleMail }}
                        </p>
                      </div>
                    </div>

                    <div class="form-group form-row">
                      <label for="" class="col-sm-4 col-form-label"
                        >Ngày tạo<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataReceipt.createdDate | formatDate('HH:mm DD/MM/YYYY') }}
                        </p>
                      </div>
                    </div>

                    <div class="form-group form-row" v-if="dataReceipt.modifiedDate">
                      <label for="" class="col-sm-4 col-form-label"
                        >Ngày cập nhật<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataReceipt.modifiedDate | formatDate('HH:mm DD/MM/YYYY') }}
                        </p>
                      </div>
                    </div>

                    <div
                      class="form-group form-row"
                      v-if="
                        dataReceipt.paymentType === 'CUSTOMER_TRANSFER' && dataReceipt.approveDate
                      "
                    >
                      <label for="" class="col-sm-4 col-form-label"
                        >Thời gian duyệt<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataReceipt.approveDate | formatDate('HH:mm DD/MM/YYYY') }}
                        </p>
                      </div>
                    </div>

                    <div
                      class="form-group form-row"
                      v-if="
                        dataReceipt.paymentType === 'CUSTOMER_TRANSFER' && dataReceipt.approveByName
                      "
                    >
                      <label for="" class="col-sm-4 col-form-label"
                        >Người duyệt<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">{{ dataReceipt.approveByName }}</p>
                      </div>
                    </div>

                    <div class="form-group form-row" v-if="dataReceipt.status === 'CANCEL'">
                      <label for="" class="col-sm-4 col-form-label"
                        >Thời gian từ chối<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataReceipt.rejectDate | formatDate('HH:mm DD/MM/YYYY') }}
                        </p>
                      </div>
                    </div>

                    <div class="form-group form-row" v-if="dataReceipt.status === 'CANCEL'">
                      <label for="" class="col-sm-4 col-form-label"
                        >Người từ chối<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">{{ dataReceipt.rejectByName }}</p>
                      </div>
                    </div>

                    <div class="form-group form-row" v-if="dataReceipt.status === 'CANCEL'">
                      <label for="" class="col-sm-4 col-form-label"
                        >Lý do từ chối<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">{{ dataReceipt.rejectReason }}</p>
                      </div>
                    </div>
                  </div>
                  <div v-if="dataReceipt.linkReceiptCode" class="form-detail linkReceipts">
                    <div class="d-flex">
                      <i class="bx bx-link icon-link mr-2"></i>
                      <p class="text-link">
                        Đã liên kết thành công với PT:
                        <a class="pt-link ml-1">{{ dataReceipt.linkReceiptCode }}</a>
                      </p>
                    </div>
                    <div
                      v-if="
                        dataPermission.includes('SCON_RECEIPT_LINK_ID') &&
                        dataReceipt.status == 'NEW' &&
                        !dataReceipt.paymentType
                      "
                      class="pt-link cancelLink"
                      @click="cancelLink"
                    >
                      Hủy liên kết
                    </div>
                  </div>
                  <div class="form-detail" v-if="dataReceipt.receiptLogRes">
                    <h1>Lịch sử sửa mã giao dịch</h1>
                    <div class="table-responsive text-center p-0">
                      <table class="w-100 mb-2">
                        <thead class="thead-gray">
                          <tr>
                            <th scope="col"><b>Thời gian</b></th>
                            <th scope="col"><b>Mã GD cũ</b></th>
                            <th scope="col"><b>Mã GD mới</b></th>
                            <th scope="col"><b>Người thực hiện</b></th>
                            <th scope="col"><b>Lý do</b></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            class="table-row"
                            v-for="(data, index) in dataReceipt.receiptLogRes"
                            :key="index"
                          >
                            <td class="text-center">
                              {{ data.createdTime | formatDate('HH:mm, DD/MM/YYYY') }}
                            </td>
                            <td class="text-center">{{ data.transactionCodeOld }}</td>
                            <td class="text-center">{{ data.transactionCodeNew }}</td>
                            <td class="text-center">{{ data.creator.name }}</td>
                            <td class="text-center">{{ data.note }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div v-if="dataReceipt.orderByQr" class="table-responsive">
                    <table class="table table-hover table-bordered" id="tableScroll">
                      <thead class="thead-light">
                        <tr>
                          <th scope="col" class="text-center">QR Order ID</th>
                          <th scope="col" class="text-center">Thời gian hết hạn</th>
                          <th scope="col" class="text-center">UDID</th>
                          <th scope="col" class="text-center">QR Code</th>
                          <th scope="col" class="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          class="table-row"
                          v-for="(item, index) in dataReceipt.orderByQr"
                          :key="index"
                        >
                          <td class="text-center">{{ item.orderId }} <br /></td>
                          <td class="text-center">
                            {{ item.expireAt | formatDate('HH:mm, DD/MM/YYYY') }}
                          </td>
                          <td class="text-center">{{ item.udid }} <br /></td>
                          <td class="text-center">{{ item.qrCode }} <br /></td>
                          <td class="text-center">
                            <div
                              @click="checkTransactionQr(item.orderId)"
                              class="f12 font-medium btn btn-outline-secondary"
                            >
                              Kiểm tra GD
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="form-detail">
                    <h1>Thông tin Merchant</h1>
                    <div class="table-responsive">
                      <table class="table table-hover table-bordered" id="tableScroll">
                        <thead class="thead-light">
                          <tr>
                            <th scope="col" class="text-center">Tên MC/Email/SĐT</th>
                            <th scope="col" class="text-center">Số hợp đồng/Phụ lục</th>
                            <th scope="col" class="text-center">Dịch vụ</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr class="table-row">
                            <td class="text-center">
                              {{ dataReceipt.merchantName }} <br />
                              {{ dataReceipt.merchantMail }} <br />
                              {{ dataReceipt.merchanMobile }}
                            </td>
                            <td class="text-center">
                              {{ dataReceipt.receiptContractCode }}
                            </td>
                            <td class="text-center">
                              <div
                                v-for="(itemm, indexx) in dataReceipt.serviceTypes"
                                :key="indexx"
                              >
                                <span v-if="itemm !== '0'">{{ itemm | serviceTypes }}</span>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <UploadMultiple
                    @syncFile="syncFile"
                    @updateImage="updateImage"
                    :lsData="fileUploads"
                    :maxFile="6"
                    title="Ảnh"
                    titleClass="form-inner-heading"
                    uniqueKey="images"
                    :saveInner="true"
                    :canRemoveOldFile="false"
                  />
                  <!-- :canUpload= "dataPermission.includes('SCON_RECEIPT_UPDATE_IMAGE') && ['PENDING_APPROVAL','DONE'].includes(dataReceipt.status) && dataReceipt.uploadImgs.length <= 6" -->

                  <div
                    class="form-detail"
                    v-if="
                      dataReceipt.refundHistoryRes &&
                      dataReceipt.refundHistoryRes.length > 0 &&
                      dataPermission.includes('CNPS_SCON_REFUND_VIEW')
                    "
                  >
                    <h1>Lịch sử hoàn tiền</h1>
                    <div class="table-responsive">
                      <table class="table table-hover table-bordered" id="tableScroll">
                        <thead class="thead-light">
                          <tr>
                            <th scope="col" class="text-center">Thời gian tạo</th>
                            <th scope="col" class="text-center">Số tiền hoàn</th>
                            <th scope="col" class="text-center">Xem chi tiết</th>
                            <th scope="col" class="text-center">Lý do hoàn</th>
                            <th scope="col" class="text-center">Người tạo</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            class="table-row"
                            v-for="(item, index) in dataReceipt.refundHistoryRes"
                            :key="index"
                          >
                            <td class="text-center">
                              {{ item.createdTime | formatDate('HH:mm, DD/MM/YYYY') }}
                            </td>
                            <td class="text-center">
                              {{ item.refundAmount | transformMoney }}
                            </td>
                            <td class="text-center">
                              <span
                                type="button"
                                class="text-primary"
                                @click="detailRefund(item.id)"
                                >Xem chi tiết</span
                              >
                            </td>
                            <td class="text-center">
                              {{ item.reason | mapTextStatus(refundReason) }}
                            </td>
                            <td class="text-center">
                              {{ item.creator.name }} <br />
                              <span class="text-primary">{{ item.creator.email }}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Modal thông báo-->
    <b-modal id="modal-scoped" v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <button type="button" class="close" @click="close()">
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" :alt="iconNoti" />
        <h2 class="f18 py-3">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>

    <div v-if="showModalReject">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Lý do từ chối</h5>
                  <button
                    type="button"
                    class="close"
                    @click="showModalReject = false"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center">
                  <form>
                    <div class="form-group pos-relative">
                      <textarea
                        v-model="dataInsert.reasonRejected"
                        class="form-control f12"
                      ></textarea>
                    </div>
                  </form>
                </div>
                <div class="modal-footer">
                  <!-- <button type="button" class="btn btn-light" data-dismiss="modal">Xác nhận</button> -->
                  <button
                    :disabled="!dataInsert.reasonRejected || !dataInsert.reasonRejected.trim()"
                    @click="rejectReceipt()"
                    class="btn btn-success"
                  >
                    Xác nhận
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <b-modal ignore-enforce-focus-selector="input" v-model="refundModal" centered size="lg">
      <template #modal-header="{ close }">
        <h5>Tạo thông tin hoàn tiền</h5>
        <b-button
          size="sm"
          variant="light"
          @click="close(), fetchFormRefund(), (refundModal = false)"
        >
          x
        </b-button>
      </template>
      <ValidationObserver class="w-100" ref="formRefund">
        <form @submit.prevent="checkValidate">
          <div class="row">
            <div class="col-md-6">
              <ValidationProvider rules="required" vid="reason" name="Lý do hoàn tiền">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Lý do hoàn tiền<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <select
                      class="select"
                      v-model="reqRefund.reason"
                      :options="refundReason"
                      disabled
                    >
                      <option v-for="option in refundReason" :value="option.id" :key="option.id">
                        {{ option.text }}
                      </option>
                    </select>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="" vid="receiptCode" name="Mã phiếu thu">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">Mã phiếu thu</label>
                  <div class="col-sm-8">
                    <input v-model.trim="reqRefund.receiptCode" disabled />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>

              <ValidationProvider rules="" vid="contractCode" name="Mã hợp đồng">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">Mã hợp đồng</label>
                  <div class="col-sm-8">
                    <input v-model.trim="dataReceipt.contractCode" disabled />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>

              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">Mã giao dịch đã thu</label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12 ml-1">{{ reqRefund.transactionCode }}</p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">Hình thức thanh toán</label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12 ml-1">
                    {{ reqRefund.paymentType | mapTextStatus(optionPaymentType) }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">Ngày đã thu</label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12 ml-1">
                    {{ reqRefund.receiptTime | formatDate('HH:mm, DD/MM/YYYY') }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">Ngày thanh toán</label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12 ml-1">
                    {{ reqRefund.payTime | formatDate('HH:mm, DD/MM/YYYY') }}
                  </p>
                </div>
              </div>
              <ValidationProvider rules="required" vid="kpiStatus" name="Tình trạng KPI">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">Tình trạng KPI</label>
                  <div class="col-sm-8">
                    <Select2 v-model="reqRefund.kpiStatus" :options="Config.kpiStatus"></Select2>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <div class="col-md-6">
              <h6>Upload ảnh</h6>
              <div class="form-group img-list">
                <ul class="m-0">
                  <li v-for="(item, index) in reqRefund.images" :key="index">
                    <a href="#popup-slider" data-toggle="modal">
                      <img :src="item" />
                      <span @click="removeImg(index)">
                        <i class="bx bx-trash bx-sm"></i>
                      </span>
                    </a>
                  </li>
                  <li>
                    <div
                      v-if="loadingImage"
                      class="add-img d-flex align-content-center justify-content-center"
                    >
                      <div class="text-center">
                        <i class="bx bx-loader-circle bx-spin bx-rotate-90 h1"></i>
                      </div>
                    </div>
                    <div
                      v-else-if="reqRefund.images && reqRefund.images.length < 10"
                      class="add-img"
                    >
                      <span class="bx bx-plus text-center"></span>
                      <input
                        type="file"
                        ref="fileImgRefund"
                        accept="image/jpeg, image/png"
                        @input="onSelectFile"
                      />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <h6 class="mb-2">Thông tin thiết bị/phần mềm hoàn tiền</h6>
          <div class="row">
            <div class="table-responsive text-center col-md-12">
              <table class="w-100 mb-2">
                <thead class="thead-gray">
                  <tr>
                    <th scope="col">
                      <input
                        type="checkbox"
                        v-model="selectProducts"
                        class="text-center"
                        @change="handleChange"
                      />
                    </th>
                    <th scope="col"><b>Loại sản phẩm</b></th>
                    <th scope="col"><b>Số tiền (VNĐ)</b></th>
                    <th scope="col"><b>Số tiền hoàn (VNĐ)</b></th>
                    <th scope="col"><b>Mã serial</b></th>
                    <th scope="col" v-if="isRentLend"><b>Khấu hao</b></th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="table-row" v-for="(item, index) in listProduct" :key="index">
                    <td class="txt-center">
                      <input
                        type="checkbox"
                        class="text-center"
                        v-model="selectedPro"
                        :value="item"
                        @change="handleChange"
                      />
                    </td>
                    <td class="text-center">{{ item.type }}</td>
                    <td class="text-center">
                      {{ (isRentLend ? item.deposit : item.price) | transformMoney }}
                    </td>
                    <td class="text-center">
                      <input
                        type="number"
                        v-model.number="item.refundAmount"
                        :disabled="selectedPro.indexOf(item) === -1"
                        @change="onRefundAmountChange(item)"
                        class="form-control text-center"
                        placeholder="0"
                      />
                    </td>
                    <td class="text-center">{{ item.serial }}</td>
                    <td class="text-center" v-if="isRentLend">{{ item?.depreciationAmount }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-if="isRentLend">
            <ValidationProvider
              rules="required|numberCheck"
              vid="reqRefund.refundAmount"
              name="Số tiền hoàn"
            >
              <div class="form-group d-flex flex-row" slot-scope="{ errors }">
                <label for="" class="col-sm-5 col-form-label"
                  ><i>Tổng số tiền hoàn/phiếu thu (VNĐ)</i><span style="color: red"> *</span></label
                >
                <div class="col-sm-7">
                  <input v-model.trim="textValue" disabled />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
          </div>

          <h6 class="mb-2">Thông tin TKNH nhận tiền hoàn</h6>
          <div class="row">
            <div class="col-md-6">
              <ValidationProvider rules="required" vid="refundRecipient" name="Đối tượng hoàn tiền">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Đối tượng hoàn tiền<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <Select2
                      v-model="reqRefund.refundRecipient"
                      :options="objectRefund"
                      @change="queryObjectRefund($event)"
                    ></Select2>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <div class="col-md-6"></div>
            <div class="col-md-6">
              <ValidationProvider rules="required" vid="bankName" name="Tên ngân hàng">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Tên ngân hàng<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <Select2
                      :options="listBank"
                      v-model="reqRefund.bankName"
                      :disabled="reqRefund.refundRecipient === 'REFUND_MERCHANT'"
                    ></Select2>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider
                rules="required|minMaxName_6"
                vid="accountNumber"
                name="Số tài khoản"
              >
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Số tài khoản <span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <input
                      v-model.trim="reqRefund.accountNumber"
                      :disabled="reqRefund.refundRecipient === 'REFUND_MERCHANT'"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <div class="col-md-6">
              <ValidationProvider rules="required|minMaxName_6" vid="branch" name="Chi nhánh">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Chi nhánh <span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <input
                      v-model.trim="reqRefund.branch"
                      :disabled="reqRefund.refundRecipient === 'REFUND_MERCHANT'"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider
                rules="required|minMaxName_6"
                vid="accountName"
                name="Tên tài khoản"
              >
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Tên tài khoản <span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <input
                      v-model.trim="reqRefund.accountName"
                      :disabled="reqRefund.refundRecipient === 'REFUND_MERCHANT'"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <div class="col-md-12">
              <ValidationProvider rules="required|minMaxName_1" vid="note" name="Ghi chú">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-2 col-form-label"
                    >Ghi chú<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-10">
                    <input v-model.trim="reqRefund.note" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
          </div>
        </form>
      </ValidationObserver>
      <template #modal-footer="{}">
        <b-button variant="primary" @click="checkValidate"> Đồng ý </b-button>
      </template>
    </b-modal>
    <modalLink
      :dataListLink="dataListLink"
      @updateLinked="updateLinked"
      :receiptIdFrom="receiptId"
      :contractId="dataReceipt.contractId"
    />
    <modalChangeCode
      v-if="modalChangeCode"
      :codeReceipt="dataReceipt.receiptCode"
      @updateChangeCode="updateChangeCode"
      :closeModalChangeCode="closeModalChangeCode"
    />
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>
<script>
  import Config from '@/thirdParty/config'
  import { ReceiptService } from '@/services/receipts.service'
  import { BankService } from '@/services/bank.service'
  import { CommonService } from '@/services/common.service'
  import { mapGetters } from 'vuex'
  import { v4 as uuidv4 } from 'uuid'
  import mxItemAction from './refund/mx-item-action.js'
  import UploadMultiple from '@/components/UploadMultiple.vue'
  import modalLink from './modal-link-receipts.vue'
  import modalChangeCode from './modal-change-code.vue'

  export default {
    data() {
      return {
        Config,
        loading: false,
        reqRefund: {
          images: [],
          infoProducts: [],
        },
        listProduct: [],
        loadingImage: false,
        refundModal: false,
        refundReason: Config.refundReason,
        listBank: [],
        customerRes: {},
        objectRefund: Config.refundRecipient,
        // optionPaymentType: Config.typePayment,
        optionPaymentType: [],
        selectedPro: [],
        receiptId: this.$route.params.receiptId,
        typeSale: JSON.parse(localStorage.getItem('userData')).typeSale,
        listAfterSale: Config.listAfterSale,
        businessFields: Config.businessFields,
        dataReceipt: {},
        groupServiceKey: {},
        dataReceiptMpos: {},
        listState: [
          { id: 'NEW', text: 'Mới tạo' },
          { id: 'PENDING_APPROVAL', text: 'Chờ duyệt' },
          { id: 'DONE', text: 'Đã thu tiền' },
          { id: 'CANCEL', text: 'Bị huỷ' },
          { id: 'WAIT_SETTLEMENT', text: 'Chờ kết toán' },
        ],
        // dataTypePayment: [
        //   { id: 'CUSTOMER_CARD', text: 'Quẹt thẻ khách' },
        //   { id: 'SALE_CARD', text: 'Quẹt thẻ Sales' },
        //   { id: 'QR_CODE', text: 'Thanh toán Qr' },
        //   { id: 'CUSTOMER_TRANSFER', text: 'Khách chuyển khoản' }
        // ],
        dataTypePayment: [],
        devicePaymentTypeData: Config.paymentType,
        notiModal: false,
        iconNoti: '',
        msgNoti: '',
        showLoading: false,
        checkShowMposTrans: false,
        dataInsert: {},
        showModalReject: false,
        checkCollectMoney: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),

        options: {
          defaultWidth: '100%',
          defaultHeight: '100%',
        },
        style: {
          width: '100%',
        },
        textValue: '',
        fileUploads: [],
        dataListLink: [],
        modalChangeCode: false,
      }
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      selectProducts: {
        get: function () {
          return this.listProduct ? this.selectedPro.length === this.listProduct.length : false
        },
        set: function (value) {
          var selectedPro = []
          if (value) {
            this.listProduct.forEach(function (item) {
              selectedPro.push(item)
            })
          }
          this.selectedPro = selectedPro
        },
      },
      isRentLend() {
        return this.reqRefund.reason === 'RENT_LEND'
      },
    },

    components: {
      UploadMultiple,
      modalLink,
      modalChangeCode,
    },
    mixins: [mxItemAction],
    filters: {
      serviceTypes(itemm) {
        const listServiceTypes = Config.listServiceTypes
        return listServiceTypes[itemm] ? listServiceTypes[itemm] : itemm
      },
      transformPaymentType(data, dataTypePayment) {
        const dataReturn = dataTypePayment.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
      transformMoney(data) {
        if (!data && data !== 0) return ''
        return data.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
      },
    },

    mounted() {
      this.configSystem()
      this.getListBank()
      this.fetchData()
    },
    watch: {
      selectedPro: {
        handler: function () {
          this.calculateTotalRefund()
        },
        deep: true,
      },
    },

    methods: {
      fetchFormRefund() {
        this.reqRefund = {
          images: [],
        }
        this.selectedPro = []
        delete this.reqRefund.bankName
        delete this.reqRefund.accountNumber
        delete this.reqRefund.branch
        delete this.reqRefund.accountName
      },
      configSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              this.dataTypePayment =
                data.data?.paymentType.map(e => {
                  return { id: e.code, text: e.name }
                }) || []
              this.optionPaymentType = this.dataTypePayment
            }
          })
          .catch(error => console.log(error))
      },
      showModal() {
        this.isModalVisible = true
      },
      closeModal() {
        this.isModalVisible = false
      },
      createRefund(item) {
        this.infoRefund(item.receiptCode)
        this.reqRefund.receiptCode = item.receiptCode
      },
      async infoRefund(receiptCode) {
        try {
          this.showLoading = true
          const data = await BankService.merchantBank({
            code: receiptCode,
          })
          if (data.success) {
            this.customerRes = data.data.customerRes
            this.listProduct = data.data.infoProducts
            this.$set(this.reqRefund, 'payTime', data.data.payTime)
            this.$set(this.reqRefund, 'paymentType', data.data.paymentType)
            this.$set(this.reqRefund, 'receiptTime', data.data.receiptTime)
            this.$set(this.reqRefund, 'transactionCode', data.data.transactionCode)
            this.$set(this.reqRefund, 'reason', data.data.reason)
            this.refundModal = true
          } else this.showFailMx(data.message)
        } catch (e) {
          console.log(e)
          this.showFailMx(e.message)
        } finally {
          this.showLoading = false
        }
      },
      async getListBank() {
        try {
          const data = await BankService.listBank()
          if (data.success) {
            this.listBank = data.data.map(e => {
              return {
                id: e.id,
                text: e.bankName,
              }
            })
          }
        } catch (error) {
          console.log(error)
        }
      },
      async getListLinkReceipt(data) {
        try {
          ReceiptService.listLinkReceipt({ contractId: data })
            .then(s => s.data?.map(s => ({ id: s.receiptId, text: s.receiptCode })) ?? [])
            .then(s => (this.dataListLink = s))
        } catch (error) {
          console.log(error)
        }
      },
      queryObjectRefund(e) {
        if (e === 'REFUND_MERCHANT') {
          this.reqRefund = {
            ...this.reqRefund,
            bankName: this.customerRes.bankId,
            accountNumber: this.customerRes.accountNo,
            branch: this.customerRes.branch,
            accountName: this.customerRes.holderName,
          }
        } else {
          delete this.reqRefund.bankName
          delete this.reqRefund.accountNumber
          delete this.reqRefund.branch
          delete this.reqRefund.accountName
        }
      },
      async onSelectFile() {
        const input = this.$refs.fileImgRefund
        const files = input.files
        if (files && files[0]) {
          const reader = new FileReader()
          reader.onload = e => {}
          reader.readAsDataURL(files[0])
          this.$emit('input', files[0])
        }
        await this.uploadS3(files[0])
      },
      removeImg(index) {
        this.reqRefund.images.splice(index, 1)
      },
      async uploadS3(file) {
        try {
          if (file) {
            this.loadingImage = true
            const formData = new FormData()
            formData.append('files', file)
            formData.append('folderName', 'NextCrm')
            const res = await CommonService.uploadImg(formData)
            if (res.code === 1000) {
              this.reqRefund.images.push(res.data[0])
            }
          }
        } catch (error) {
        } finally {
          this.loadingImage = false
        }
      },
      async checkValidate() {
        this.reqRefund.infoProducts = this.selectedPro
        this.reqRefund.bankId = this.reqRefund.bankName
        this.reqRefund.bankName =
          this.listBank.find(s => s.id === this.reqRefund.bankName)?.text ?? ''
        this.reqRefund.refundAmount = Number(this.textValue)
        this.reqRefund.contractCode = this.dataReceipt.contractCode

        // For RENT_LEND reason, validate that at least one checkbox is selected
        if (this.reqRefund.reason === 'RENT_LEND' && this.selectedPro.length === 0) {
          this.showFailMx('Vui lòng chọn ít nhất một thiết bị/phần mềm để hoàn tiền')
          return
        }

        const isSuccess = await this.$refs.formRefund.validate()
        if (!isSuccess && this.reqRefund.infoProducts.length < 1) {
          return
        }
        if (this.reqRefund.reason === 'REFUND_MERCHANT') {
          this.addRefund(this.reqRefund)
        } else {
          this.checkBankAccount(this.reqRefund)
        }
      },
      async checkBankAccount(reqRefund) {
        try {
          this.showLoading = true
          const data = await BankService.checkBank({
            bankId: reqRefund.bankId,
            holderName: reqRefund.accountName,
            accountNo: reqRefund.accountNumber,
          })
          if (data.success) {
            this.addRefund(reqRefund)
          } else {
            if (data.code === 641 || data.code === 642) {
              const flag = await this.approveMx(
                'Trong một số trường hợp dịch vụ kiểm tra thông tin phía ngân hàng không ổn định, thông báo này cũng sẽ được hiển thị. Nếu đã đảm bảo tính xác thực của thông tin, bạn có thể chọn tiếp tục?'
              )
              if (flag === true) {
                await this.addRefund(reqRefund)
              }
            } else {
              this.showFailMx(data.message)
            }
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async addRefund(reqRefund) {
        try {
          this.showLoading = true
          this.refundModal = false
          const data = await ReceiptService.createRefund(reqRefund)
          if (data.success) {
            await this.fetchData()
            this.showSuccessMx('Tạo thông tin hoàn tiền thành công')
          } else {
            this.showFailMx(data.message)
          }
          this.fetchFormRefund()
        } catch (err) {
          console.log(err)
        } finally {
          this.showLoading = false
        }
      },
      detailRefund(idRefund) {
        window.open(`/list-refund/${idRefund}`, '_blank')
      },
      backToList() {
        this.$router.push('/list-receipts')
      },
      editReceipts() {
        if (
          this.dataReceipt.createdBy === this.dataUser.userId ||
          this.dataUser.typeSale === 'SALE_DIRECTOR'
        ) {
          this.$router.push(`/edit-receipts/${this.dataReceipt.receiptId}/detail`)
        } else {
          this.errorModal('Bạn chỉ được sửa phiếu thu của mình')
        }
      },
      async checkMposTrans() {
        try {
          this.showLoading = true
          const response = await ReceiptService.checkMposTrans({
            receiptId: this.receiptId,
            amount: this.dataReceipt.amount,
            issuerCode: this.dataReceipt.issuerCode,
            transactionCode: this.dataReceipt.transactionCode,
          })
          if (response.code === 1000) {
            this.successModal(
              `Kiểm tra ${this.dataReceipt.transactionCode} thành công. Giao dịch đang ở trạng thái ${response.data.tranStatusDisplay}`
            )
            this.dataReceiptMpos.description = response.data.description
            this.dataReceiptMpos.amount = response.data.amount
            if (
              response.data.tranStatusCode === 'SETTLED' ||
              response.data.tranStatusCode === 'TRANSFERED'
            ) {
              this.checkShowMposTrans = true
            }
          } else if (response.code === 999) {
            this.errorModal(
              'Không kiểm tra được thông tin GD bên mPOS. Vui lòng kiểm tra lại Mã chuẩn chi/mã GD'
            )
          } else if (response.code === 998) {
            this.errorModal(
              'Mã chuẩn chi tồn tại ở nhiều giao dịch. Vui lòng nhập mã giao dịch và nhấn Kiểm tra lại để hoàn thiện phiếu thu'
            )
          } else if (response.code === 997) {
            this.errorModal(
              'Số tiền trên giao dịch mPOS khác số tiền trên phiếu thu. Vui lòng kiểm tra lại'
            )
          } else {
            this.errorModal(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async fetchData() {
        try {
          this.fileUploads = []
          this.showLoading = true
          const data = await ReceiptService.detailReceipts({
            receiptId: this.receiptId,
          })
          if (data.success) {
            this.dataReceipt = data.data
            if (!data.data.linkReceiptCode) {
              this.getListLinkReceipt(data.data.contractId)
            }
            const mappingData = (arr, type) =>
              arr.forEach(url => {
                const ar = { name: url, url, type, id: uuidv4() }
                this.fileUploads.push(ar)
              })
            await mappingData(data.data.uploadImgs, 'images')
            if (!data.data.linkReceiptCode) {
              this.getListLinkReceipt(data.data.contractId)
            }
          } else {
            alert('Đã xảy ra lỗi')
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async collectedMoney() {
        try {
          this.showLoading = true
          const response = await ReceiptService.collectedMoney({
            receiptId: this.receiptId,
            description: this.dataReceipt.description,
          })
          if (response.code === 1000) {
            this.successModal(response.message)
          } else {
            this.errorModal(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async approveReceipt() {
        try {
          this.showLoading = true
          const response = await ReceiptService.approveReceipt({
            receiptId: this.receiptId,
            description: this.dataReceipt.description,
          })
          if (response.code === 1000) {
            this.successModal(response.message)
            await this.fetchData()
          } else {
            this.errorModal(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      canExportReceiptInvoice(item) {
        // Trạng thái: Mới tạo | Chờ duyệt | Chờ kết toán | Đã thu tiền
        // - Trạng thái xuất hóa đơn: Chưa xuất hóa đơn
        // - Số tiền: Khác 0 đồng
        return (
          this.dataPermission.includes('SCON_RECEIPT_EXPORT_INVOICE') &&
          item.invoiceStt === false &&
          item.amount !== 0 &&
          ['NEW', 'PENDING_APPROVAL', 'DONE', 'WAIT_SETTLEMENT'].includes(item.status)
        )
      },
      async exportReceiptInvoice(item) {
        try {
          const check = this.canExportReceiptInvoice(item)
          if (!check) {
            this.showFailMx('Không có quyền truy cập')
            return false
          }
          this.showLoading = true
          const data = await ReceiptService.exportReceiptInvoice({ receiptId: item.receiptId })
          if (data.success) {
            this.notiModal = true
            this.iconNoti = require('@/assets/img/noti-success2.svg')
            this.msgNoti = data.message
          } else {
            this.notiModal = true
            this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
            this.msgNoti = data.message
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async rejectReceipt() {
        try {
          this.showLoading = true
          const response = await ReceiptService.rejectReceipt({
            receiptId: this.receiptId,
            rejectReason: this.dataInsert.reasonRejected,
          })
          if (response.code === 1000) {
            this.successModal(response.message)
            await this.fetchData()
          } else {
            this.errorModal(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showModalReject = false
          this.showLoading = false
        }
      },

      async sendApproved() {
        try {
          this.showLoading = true
          const response = await ReceiptService.sendToApproveReceipt_detail({
            receiptId: this.receiptId,
          })
          if (response.code === 1000) {
            this.successModal(response.message)
            await this.fetchData()
          } else {
            this.errorModal(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      successModal(msg) {
        this.notiModal = true
        this.iconNoti = require('@/assets/img/noti-success2.svg')
        this.msgNoti = msg
      },
      errorModal(msg) {
        this.notiModal = true
        this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
        this.msgNoti = msg
      },
      calculateTotalRefund() {
        if (this.isRentLend) {
          // Logic cho RENT_LEND: Tổng = tổng deposit của items được chọn + tổng refundAmount đã nhập
          const totalRefundAmount = this.selectedPro.reduce((total, item) => {
            // const deposit = Number(item.deposit) || 0
            const refundAmount = Number(item.refundAmount) || 0
            return total + refundAmount
          }, 0)
          this.reqRefund.refundAmount = totalRefundAmount
          this.textValue = totalRefundAmount
        } else {
          // Logic cho các reason khác: Tổng = tổng price của items được chọn
          const totalRefundAmount = this.selectedPro.reduce((total, item) => {
            const price = Number(item.price) || 0
            return total + price
          }, 0)
          this.reqRefund.refundAmount = totalRefundAmount
          this.textValue = totalRefundAmount
        }
      },

      handleChange(event) {
        this.calculateTotalRefund()
      },

      onRefundAmountChange(item) {
        this.$nextTick(() => {
          this.calculateTotalRefund()
        })
      },
      async submitAddImage(data) {
        try {
          const params = {
            receiptId: this.receiptId,
            uploadImgs: data,
          }
          this.showLoading = true
          const response = await ReceiptService.addImageDetail(params)
          if (response.code === 1000) {
            this.successModal(response.message)
            this.fileUploads = []
            await this.fetchData()
          } else {
            this.errorModal(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      syncFile(files) {
        this.fileUploads = files
      },
      async sendFile(item) {
        if (item.file && item.status !== 'uploaded') {
          const formData = new FormData()
          formData.append('files', item.file)
          formData.append('folderName', 'NextCrm')
          const data = await CommonService.uploadImg(formData)
          const urlFile = data.data[0]
          item.url = urlFile
          item.status = 'uploaded'
          return urlFile
        } else return item.url
      },
      async updateImage() {
        try {
          this.$emit('close')
          this.showLoading = true
          const files = await Promise.all(this.fileUploads.map(s => this.sendFile(s)))
          this.submitAddImage(files)
          this.showLoading = false
        } catch (error) {
          console.log(error)
        }
      },
      connectReceipts() {
        console.log('huy')
        this.$bvModal.show('link-receipts')
      },
      async updateLinked(params) {
        try {
          this.showLoading = true
          const data = await ReceiptService.createLink(params)
          if (data.success) {
            await this.fetchData()
            this.showSuccessMx('Liên kết phiếu thu thành công')
          } else {
            this.showFailMx(data.message)
          }
          this.fetchFormRefund()
        } catch (err) {
          console.log(err)
        } finally {
          this.showLoading = false
          this.$bvModal.hide('link-receipts')
        }
      },
      async cancelLink() {
        const flag = await this.approveMx(
          `Bạn có chắc chắn muốn hủy liên kết giữa phiếu thu ${this.dataReceipt.receiptCode} và phiếu thu ${this.dataReceipt.linkReceiptCode} không?`
        )
        if (flag === true) {
          this.showLoading = true
          const res = await ReceiptService.cancelLink({
            receiptId: this.receiptId,
          })
          this.showLoading = false
          if (res.success === true) {
            this.showSuccessMx('Hủy liên kết phiếu thu thành công')
            this.fetchData()
          } else this.showFailMx(res.message)
        }
      },
      showModalChangeCode() {
        this.modalChangeCode = true
        this.$nextTick(s => this.$bvModal.show('change-code-receipt'))
      },
      async updateChangeCode(data) {
        try {
          this.showLoading = true
          data.id = this.dataReceipt.receiptId
          const response = await ReceiptService.changeCodeReceipt(data)
          if (response.code === 1000) {
            this.successModal(response.message)
            this.closeModalChangeCode()
            await this.fetchData()
          } else {
            this.errorModal(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async checkTransactionQr(orderId) {
        try {
          const params = {
            id: this.receiptId,
            orderId,
          }
          this.showLoading = true
          const data = await ReceiptService.checkTransactionQr(params)
          if (data.success) {
            await this.fetchData()
            this.showSuccessMx(data.message)
          } else {
            this.showFailMx(data.message)
          }
        } catch (err) {
          console.log(err)
        } finally {
          this.showLoading = false
        }
      },
      closeModalChangeCode() {
        this.$bvModal.hide('change-code-receipt')
        this.modalChangeCode = false
      },
    },
  }
</script>

<style scoped>
  .DONE,
  .ACTIVE {
    color: #fff;
    background-color: #007bff;
  }

  .PENDING_APPROVAL,
  .PENDING_CONFIRM_APPROVAL,
  .WAIT_SETTLEMENT {
    color: #fff;
    background-color: #ffc107;
  }

  .CANCEL {
    color: #fff;
    background-color: #dc3545;
  }

  table th {
    background-color: #dee2e6;
    border: 1px solid #cacaca;
  }

  .select {
    background-color: #e2e7ed;
    border: 1px solid #ccc;
  }

  .icon-link {
    font-size: 22px;
    padding: 3px;
    background-color: rgb(91, 91, 241);
    border-radius: 50%;
    color: #fff;
  }

  .text-link {
    font-size: 14px;
    display: flex;
    align-items: center;
  }

  .pt-link {
    color: #007bff;
  }

  .linkReceipts {
    display: flex;
    justify-content: space-between;
  }

  .cancelLink {
    font-size: 14px;
    align-items: center;
    display: flex;
    cursor: pointer;
  }
</style>
